"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCheckCircle = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M28.477 14.947a1 1 0 11-.814 1.826A9 9 0 1033 25v-.93a1 1 0 012 0V25a11 11 0 11-6.523-10.053zm7.23.346a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L24 25.586l10.293-10.293a1 1 0 011.414 0z",
    id: "check-circle_svg__a"
  }));
};

var _default = SvgCheckCircle;
exports.default = _default;